module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp3_6000.23774b05.png";